/*
  Puff Panda — native-app pass.
  Progressive enhancement only: every piece here degrades to a normal link
  or a normal <form> submit if anything fails, so it never blocks browsing,
  search, or checkout.
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function ageAllowed() {
    try {
      return window.localStorage.getItem('pp_age_verified') === 'allowed';
    } catch (e) {
      return false;
    }
  }

  function whenAgeAllowed(cb) {
    if (ageAllowed()) {
      cb();
      return;
    }
    var yesBtn = document.getElementById('pp-age-gate-yes');
    if (yesBtn) {
      yesBtn.addEventListener('click', function () {
        setTimeout(cb, 50);
      }, { once: true });
    } else {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (ageAllowed() || tries > 75) {
          clearInterval(iv);
          if (ageAllowed()) cb();
        }
      }, 400);
    }
  }

  /* ---------------- Bottom tab bar: cart tab opens the real cart drawer ---------------- */

  function initBottomNavCart() {
    var trigger = document.getElementById('pp-bottom-nav-cart');
    if (!trigger) return;
    trigger.addEventListener('click', function (event) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        event.preventDefault();
        drawer.open(trigger);
      }
      // else: let the default <a href="/cart"> navigation happen.
    });
  }

  function initBottomNavBadgeSync() {
    var badge = document.getElementById('pp-bottom-nav-cart-badge');
    var source = document.getElementById('cart-icon-bubble');
    if (!badge || !source) return;

    function sync() {
      var countEl = source.querySelector('.cart-count-bubble span[aria-hidden]');
      var count = countEl ? countEl.textContent.trim() : '0';
      badge.textContent = count;
      badge.setAttribute('data-count', count);
    }

    sync();
    try {
      new MutationObserver(sync).observe(source, { subtree: true, childList: true, characterData: true });
    } catch (e) {
      /* MutationObserver unsupported — badge keeps its server-rendered count. */
    }
  }

  /* ---------------- Install prompt ---------------- */

  function initInstallPrompt() {
    var root = document.getElementById('pp-install-prompt');
    if (!root) return;

    var DISMISS_KEY = 'pp_install_dismissed';
    var deferredPrompt = null;

    function dismissed() {
      try {
        return window.localStorage.getItem(DISMISS_KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    function setDismissed() {
      try {
        window.localStorage.setItem(DISMISS_KEY, '1');
      } catch (e) {
        /* no-op */
      }
    }

    function isStandalone() {
      return (
        (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
        window.navigator.standalone === true
      );
    }

    function isIosSafari() {
      var ua = window.navigator.userAgent;
      var iOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      return iOS && /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);
    }

    function show(mode) {
      if (dismissed() || isStandalone()) return;
      root.hidden = false;
      root.setAttribute('data-mode', mode);
    }

    function hide() {
      root.hidden = true;
    }

    window.addEventListener('beforeinstallprompt', function (event) {
      event.preventDefault();
      deferredPrompt = event;
      whenAgeAllowed(function () {
        show('android');
      });
    });

    window.addEventListener('appinstalled', function () {
      setDismissed();
      hide();
    });

    var closeBtn = root.querySelector('.pp-install-prompt__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setDismissed();
        hide();
      });
    }

    var installBtn = root.querySelector('.pp-install-prompt__btn');
    if (installBtn) {
      installBtn.addEventListener('click', function () {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        deferredPrompt.userChoice.finally(function () {
          deferredPrompt = null;
          setDismissed();
          hide();
        });
      });
    }

    if (isIosSafari()) {
      whenAgeAllowed(function () {
        show('ios');
      });
    }
  }

  /* ---------------- Sticky mobile add-to-cart ---------------- */
  /* Built entirely client-side (no template edits): mirrors the existing,
     already-working buy-buttons form rather than re-implementing cart-add. */

  function initStickyAtc() {
    var main = document.querySelector('main[data-template="product"]');
    if (!main) return;

    var realBtn = main.querySelector('.product-form__submit');
    if (!realBtn) return;

    var bar = document.createElement('div');
    bar.id = 'pp-sticky-atc';
    bar.className = 'pp-sticky-atc';
    bar.innerHTML =
      '<span class="pp-sticky-atc__price"></span>' +
      '<button type="button" class="pp-sticky-atc__btn"><span></span></button>';
    document.body.appendChild(bar);

    var priceSource = main.querySelector('.price');
    var priceTarget = bar.querySelector('.pp-sticky-atc__price');
    var stickyBtn = bar.querySelector('.pp-sticky-atc__btn');

    function syncPrice() {
      if (!priceSource || !priceTarget) return;
      var item =
        priceSource.querySelector('.price-item--sale, .price-item--regular') || priceSource;
      var text = item.textContent.replace(/\s+/g, ' ').trim();
      if (text) priceTarget.textContent = text;
    }

    function syncButtonState() {
      if (!stickyBtn) return;
      stickyBtn.disabled = realBtn.disabled;
      var label = realBtn.textContent.replace(/\s+/g, ' ').trim();
      if (label) stickyBtn.querySelector('span').textContent = label;
    }

    syncPrice();
    syncButtonState();

    try {
      if (priceSource) {
        new MutationObserver(syncPrice).observe(priceSource, {
          subtree: true,
          childList: true,
          characterData: true,
        });
      }
      new MutationObserver(syncButtonState).observe(realBtn, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
        characterData: true,
      });
    } catch (e) {
      /* MutationObserver unsupported — sticky bar keeps its initial state. */
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (realBtn.disabled) return;
        realBtn.click();
      });
    }

    try {
      new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          bar.classList.toggle('pp-is-visible', !entry.isIntersecting);
        },
        { rootMargin: '0px 0px -10% 0px' }
      ).observe(realBtn);
    } catch (e) {
      // No IntersectionObserver support — leave the sticky bar hidden rather
      // than guess at scroll position.
    }
  }

  /* ---------------- Product gallery dots (mobile) ---------------- */
  /* Dawn's gallery already swipes natively (scroll-snap); this only adds a
     dot-style position indicator, inserted client-side next to it. */

  function initGalleryDots() {
    var slider = document.querySelector('[id^="Slider-Gallery-"]');
    if (!slider) return;

    var slides = slider.querySelectorAll('.slider__slide');
    if (slides.length < 2) return;

    var host = slider.closest('slider-component') || slider.parentElement;
    if (!host) return;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'pp-gallery-dots pp-has-dots';
    dotsWrap.setAttribute('aria-hidden', 'true');
    host.insertAdjacentElement('afterend', dotsWrap);

    var dots = [];
    slides.forEach(function (_, index) {
      var dot = document.createElement('span');
      dot.className = 'pp-gallery-dots__dot';
      dot.setAttribute('aria-hidden', 'true');
      if (index === 0) dot.setAttribute('aria-current', 'true');
      dotsWrap.appendChild(dot);
      dots.push(dot);
    });

    function setActive(index) {
      dots.forEach(function (dot, i) {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    try {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var index = Array.prototype.indexOf.call(slides, entry.target);
              if (index > -1) setActive(index);
            }
          });
        },
        { root: slider, threshold: 0.6 }
      );
      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    } catch (e) {
      /* No IntersectionObserver — dots stay on the first slide. */
    }
  }

  /* ---------------- Recently viewed products ---------------- */
  /* Client-side only: records each viewed product into localStorage as
     minimal JSON (handle/title/url/image/price), then renders a row on
     product pages excluding the current item. No network calls, no app,
     degrades to nothing if localStorage is unavailable. */

  function initRecentlyViewed() {
    var main = document.querySelector('main[data-template="product"]');
    if (!main) return;

    var ldJsonEl = main.querySelector('script[type="application/ld+json"]');
    if (!ldJsonEl) return;

    var productData;
    try {
      productData = JSON.parse(ldJsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!productData || productData['@type'] !== 'Product') return;

    var offer = Array.isArray(productData.offers) ? productData.offers[0] : productData.offers;
    var image = Array.isArray(productData.image) ? productData.image[0] : productData.image;
    var priceText = '';
    if (offer && offer.price) {
      priceText = offer.priceCurrency ? offer.priceCurrency + ' ' + offer.price : String(offer.price);
    }

    var current = {
      handle: window.location.pathname,
      title: productData.name || '',
      url: window.location.pathname,
      image: image || '',
      price: priceText,
    };
    if (!current.title) return;

    var STORAGE_KEY = 'pp_recently_viewed';
    var MAX_ITEMS = 8;

    function getStored() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return [];
      }
    }

    function setStored(items) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      } catch (e) {
        /* localStorage unavailable — nothing persists, feature just no-ops. */
      }
    }

    var stored = getStored().filter(function (item) {
      return item.handle !== current.handle;
    });

    var toRender = stored.slice(0, MAX_ITEMS);

    stored.unshift(current);
    setStored(stored.slice(0, MAX_ITEMS));

    if (toRender.length === 0) return;

    var section = document.createElement('section');
    section.className = 'pp-recently-viewed page-width';
    section.setAttribute('aria-label', 'Recently viewed products');

    var heading = document.createElement('h2');
    heading.className = 'pp-recently-viewed__heading';
    heading.textContent = 'Recently Viewed';
    section.appendChild(heading);

    var list = document.createElement('ul');
    list.className = 'pp-recently-viewed__list';
    section.appendChild(list);

    toRender.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'pp-recently-viewed__item';

      var a = document.createElement('a');
      a.href = item.url;

      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 300;
        img.height = 300;
        a.appendChild(img);
      }

      var title = document.createElement('span');
      title.className = 'pp-recently-viewed__item-title';
      title.textContent = item.title;
      a.appendChild(title);

      var price = document.createElement('span');
      price.className = 'pp-recently-viewed__item-price';
      price.textContent = item.price;
      a.appendChild(price);

      li.appendChild(a);
      list.appendChild(li);
    });

    main.appendChild(section);
  }

  ready(function () {
    initBottomNavCart();
    initBottomNavBadgeSync();
    initInstallPrompt();
    initStickyAtc();
    initGalleryDots();
    initRecentlyViewed();
  });
})();
